import {IActivity} from "../../activities/activity";
import {OngoingActivityAction, UPDATE_ONGOING_ACTIVITY, UpdateOngoingActivity} from "../actions";

export const initialState: IActivity = null;

export function reducer(state: IActivity = initialState, action: OngoingActivityAction): IActivity {

  switch (action.type) {

    case UPDATE_ONGOING_ACTIVITY:
      return (<UpdateOngoingActivity>action).payload;
  }

  return state;
}
